const stats = [
  { value: "40+", label: "收录影视作品", icon: "ri-film-line" },
  { value: "12", label: "主要奖项与提名", icon: "ri-award-line" },
  { value: "26", label: "合作导演与团队", icon: "ri-team-line" },
  { value: "2016", label: "出道年份", icon: "ri-calendar-check-line" },
];

export default function StatsBand() {
  return (
    <section className="rounded-lg bg-primary-950 px-6 md:px-10 py-8 md:py-10">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {stats.map((stat) => (
          <div key={stat.label} className="flex flex-col sm:flex-row sm:items-center gap-3">
            <span className="w-12 h-12 rounded-lg bg-background-50/10 text-accent-400 flex items-center justify-center shrink-0">
              <i className={`${stat.icon} text-2xl`}></i>
            </span>
            <span>
              <span className="block font-heading text-2xl md:text-3xl font-semibold text-background-50">
                {stat.value}
              </span>
              <span className="block mt-1 text-xs md:text-sm text-background-50/60">
                {stat.label}
              </span>
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}